/**
 * @author       david.loehr@zumper.com (David Loehr)
 * @copyright    Copyright (c) 2025, Zumper
 * @description  Constants for lifestyles module
 */

export const RECEIVE_LIFESTYLE_SCORES_FOR_ADDRESS_ID =
  '@@nzr/detail/lifestyles/RECEIVE_LIFESTYLE_SCORES_FOR_ADDRESS_ID'
export const START_FETCHING_LIFESTYLE_SCORES_FOR_ADDRESS_ID =
  '@@nzr/detail/lifestyles/START_FETCHING_LIFESTYLE_SCORES_FOR_ADDRESS_ID'

export const RECEIVE_LIFESTYLE_SCORES_FOR_GROUP_ID =
  '@@nzr/detail/lifestyles/RECEIVE_LIFESTYLE_SCORES_FOR_GROUP_ID'
export const START_FETCHING_LIFESTYLE_SCORES_FOR_GROUP_ID =
  '@@nzr/detail/lifestyles/START_FETCHING_LIFESTYLE_SCORES_FOR_GROUP_ID'
